<section class="landing-inversores__trust-stats">
  <div class="landing-inversores__container landing-inversores__trust-stats-grid">
    <div class="landing-inversores__trust-stats-item" *ngFor="let s of stats">
      <landing-inversores-icon [name]="s.icon" class="landing-inversores__trust-stats-icon"></landing-inversores-icon>
      <p class="landing-inversores__trust-stats-value">{{ s.k }}</p>
      <p class="landing-inversores__trust-stats-label">{{ s.v }}</p>
    </div>
  </div>
</section>
